// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__jbLLy","container":"SectionFaq_container__RHUxe","faq__title":"SectionFaq_faq__title__Ljz8M","faq__list-container":"SectionFaq_faq__list-container__In_x5"};